import React from 'react';
import { PRICE_TOGGLE_TYPE_BOTH } from '../constants';
import { useTypedSelector } from './useTypedSelector';

const useShowBothPrices = () => {
  const { currentType } = useTypedSelector((state) => state.priceToggle);
  return currentType === PRICE_TOGGLE_TYPE_BOTH;
};

export default useShowBothPrices;
